import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../components/config/appConfig'
import { useSelector, useDispatch } from "react-redux";
import { getActiveProjectData} from '../Redux/Reducer/index';
import { jwtDecode } from "jwt-decode";
import { setLoaderStatus } from '../Redux/Reducer/index';
import ProjectAccessControl from '../../components/ProjectAccessControl/index'
import ProjectSettings from "../../containers/Dashboard/ProjectPages/ProjectDetailsPage/ProjectSettings";


const RoleProtected = ({ children, allowedRoles, userId }) => {
    // console.log("Req Body",allowedRoles, userId)
  const [userProjects, setUserProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

  const { projectSlug } = useParams(); 
//   console.log(" projectSlug =",projectSlug)
  const dispatch = useDispatch()

//   const getSlug = async ()=>{
//     let projectInfo = await dispatch(getActiveProjectData(projectSlug))
//     console.log("projectInfo",projectInfo)
//   }


  useEffect(() => {
    getUserProjects();
    // getSlug()
  }, []);

  const getUserProjects = async () => {
    setIsLoading(true)
    try {
        const token = localStorage.getItem('accessToken');
        const decoded = jwtDecode(token);
        const response = await axios.get(`${API_BASE_URL}/projects?userid=${decoded.id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        const projectsData = response.data;
        setUserProjects(projectsData)
    setIsLoading(false)

        // console.log("projectsData",projectsData)
    } catch (error) {
        console.error('Error fetching user projects:', error);
    }
};

  // Find the current project by the project slug
  const findProjectBySlug = (slug) => {
    // console.log("Checking slug:", slug); 
    return userProjects.find(project => {
    //   console.log("Project slug:", project.slugString);
      return project.slugString === slug;
    });
  };
  

  // Get the current project based on the slug from the URL
  const currentProject = findProjectBySlug(projectSlug);
//   console.log("currentProject",currentProject)

  if (isLoading) {
    return <div><ProjectSettings/></div>;
  }

//   if (error) {
//     return <div>Error loading projects: {error.message}</div>;
//   }

  if (!currentProject) {
    return <Navigate to={`/projects/${projectSlug}/settings`} replace />;
  }

  const userContributor = currentProject.contributors.find(contributor => contributor.employeeId === userId);
//   console.log("userContributor",userContributor)

  if (!userContributor || !allowedRoles.includes(userContributor.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RoleProtected;